import { ReactNode } from "react";
import ResponsiveContainer from "./ResponsiveContainer";

interface ResponsiveSectionProps {
  children: ReactNode;
  variant?: "default" | "accent" | "card";
  spacing?: "sm" | "md" | "lg" | "xl";
  containerSize?: "sm" | "md" | "lg" | "xl" | "full";
  className?: string;
}

const ResponsiveSection = ({ 
  children, 
  variant = "default",
  spacing = "md",
  containerSize = "lg",
  className = ""
}: ResponsiveSectionProps) => {
  
  const variantClasses = {
    default: "",
    accent: "",
    card: ""
  };

  const spacingClasses = {
    sm: "py-6 sm:py-8 lg:py-10",
    md: "py-8 sm:py-12 lg:py-16",
    lg: "py-12 sm:py-16 lg:py-20",
    xl: "py-16 sm:py-20 lg:py-24"
  };

  return (
    <section className={`${variantClasses[variant]} ${spacingClasses[spacing]} ${className}`}>
      <ResponsiveContainer size={containerSize}>
        {children}
      </ResponsiveContainer>
    </section>
  );
};

export default ResponsiveSection;
